import React, { useRef } from 'react'
import { useIntl } from 'react-intl'

import { AlertBox, Icons, Button } from 'msp-components'
import { IMachine, useAccount } from 'msp-integrations'

import translations from './AccountMachineRemove.constants'
import * as S from './AccountMachineRemove.styles'

export type AccountMachineRemoveProps = {
  machine: IMachine
}

const AccountMachineRemove = ({ machine }: AccountMachineRemoveProps) => {
  const { formatMessage } = useIntl()
  const confirmBoxRef = useRef<AlertBox>()
  const {
    machines: { isProcessingAction, removeMachine }
  } = useAccount()

  const confirmAction = () => {
    const payload = {
      SerialNo: machine.SerialNo
    }

    removeMachine({ body: payload })
  }

  return (
    <>
      <div
        className={`${S.ButtonWrapper} ${S.ButtonUnderline}`}
        onClick={() =>
          !isProcessingAction && confirmBoxRef?.current.showAlert()
        }
      >
        {formatMessage(translations.removeMachine)}
      </div>
      <AlertBox
        ref={confirmBoxRef}
        type='standard'
        headlineColor={S.ConfirmationHeadline}
        title={formatMessage(translations.cancellationTitle)}
        closeButtonIcon={<Icons iconName='Close' size='base' />}
      >
        <div className={S.ConfirmationHeadline}>
          <div className={S.ConfirmationDescription}>
            {formatMessage(translations.cancellationDescription)}
          </div>

          <div className={S.ConfirmationSerialNo}>
            {machine.SerialNo} ({machine.model})
          </div>

          <div className={S.ConfirmationNote}>
            {formatMessage(translations.cancellationNote)}
          </div>
        </div>

        <div className={S.ConfirmationButtonsWrapper}>
          <Button
            type={'secondary'}
            variant='outline'
            className={S.ConfirmationCancelButton}
            onClick={() => confirmBoxRef?.current.closeAlert()}
          >
            {formatMessage(translations.cancellationCancel)}
          </Button>
          <Button type='secondary' onClick={() => confirmAction()}>
            {formatMessage(translations.cancellationConfirm)}
          </Button>
        </div>
      </AlertBox>
    </>
  )
}

export default AccountMachineRemove
